import { Platform } from "react-native";

//TODO: unify with AppConfig

class Configuration {
  API_VERSION = "/v1";
  //API_URL = "http://localhost:8888" + this.API_VERSION;
  API_URL = "https://app.mana.ai:8888" + this.API_VERSION;

  API_KEY = "6cb848aeaa0d42c4afac37fd6d5e6d7b";
  SECRET = "dGVzdDEyMzQ=";

  GOOGLE_CLIENT_ID_WEB =
    "413133080887-el4hnvv6kotg56336eq97ick20neknbv.apps.googleusercontent.com";
  GOOGLE_API_KEY_WEB = "AIzaSyAGkIhjKNpuR8zthC88GFrycGjA52D6zsk";

  GOOGLE_CLIENT_ID =
    Platform.OS === "ios"
      ? "413133080887-6hpvgjr83ej4uknd30lo7e2ubfp64f7h.apps.googleusercontent.com"
      : Platform.OS === "android"
      ? "413133080887-qeaq01drlkehufi7m9vjp5lsukcfr58h.apps.googleusercontent.com"
      : "413133080887-el4hnvv6kotg56336eq97ick20neknbv.apps.googleusercontent.com";
  GOOGLE_API_KEY =
    Platform.OS === "ios"
      ? "AIzaSyDATafNWvAwmJ4-5xAor7hA8RCTjeU3-LQ"
      : Platform.OS === "android"
      ? "AIzaSyB5r-j9vF1V6OWvOKkoCTh6sy68gN4-3gY"
      : "AIzaSyAGkIhjKNpuR8zthC88GFrycGjA52D6zsk";
}

export default Configuration;
